import React, { useState } from 'react';
import { UniversalLink } from '@plone/volto/components';
import { Pagination } from 'semantic-ui-react';
import './styles.css';

const NotiziaInEvidenzaView = (props) => {
  const { data, items: propItems } = props;
  const [activePage, setActivePage] = useState(1);

  const { image, titleText, text, buttonText, buttonLink } = data;
  
  const cardStyle = data.cardStyle || 'simple';
  const title = data.title || '';
  const bigTitle = data.bigTitle || '';
  const descrizione = data.descrizione || '';
  const testoLink = data.testoLink;
  const linkApprofondimento = data.linkApprofondimento;
  const showDots = data.showDots === 'yes';
  const dotsPosition = data.dotsPosition || 'both';
  const titleAlignment = data.titleAlignment || 'left';
  const contentAlignment = data.contentAlignment || 'middle';
  const styleElementInEvidence = data.styleElementInEvidence || 'chiaro';
  
  const allItems = Array.isArray(propItems) 
    ? propItems 
    : Array.isArray(data.items) 
      ? data.items 
      : [];

  const itemsPerPage = data.enablePagination ? data.itemsPerPage || 4 : data.resultsPerPage || 4;
  const totalPages = Math.ceil(allItems.length / itemsPerPage);
  const startIndex = (activePage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const visibleItems = data.enablePagination 
    ? allItems.slice(startIndex, endIndex)
    : allItems.slice(0, itemsPerPage);

  const imageSrc = image?.data
    ? `data:${image['content-type']};base64,${image.data}`
    : image?.download || image;
    
  const renderIconFromTipoElementi = () => {
    switch (data.tipoElementi) {
      case 'baby':
        return <svg className="blue-child" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z" /></svg>;
      case 'circle':
        return <svg className="blue-child" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z" /></svg>;
      case 'spinner':
        return <svg className="blue-child" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z" /></svg>;
      default:
        return null;
    }
  };

  const renderIconFromTipoElementiDopo = () => {
      switch (data.tipoElementi) {
        case 'baby':
          return <svg className="yellow-child" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"/></svg>;
        case 'circle':
          return <svg className="yellow-child" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"/></svg>;
        case 'spinner':
          return <svg className="yellow-child" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"/></svg>;
        default:
          return null;
      }
    };

  return (
    <div 
      className="full-width-item-evidence-wrapper"
    >
      <div 
        className={`full-width-item-evidence vertical-${contentAlignment}`}
        style={imageSrc ? { backgroundImage: `url(${imageSrc})` } : {}}
      >
        <div className={`content-overlay vertical-${contentAlignment}`}>
          {(title || bigTitle || descrizione || testoLink) && (
            <div className={`content-container alignment-${titleAlignment} theme-${styleElementInEvidence}`}>
              {title && (
                <div className={`title-section ${titleAlignment} ${bigTitle ? 'h2' : titleText ? 'h3' : 'h4'}`}>
                  {showDots && (dotsPosition === 'before' || dotsPosition === 'both') && (
                    <span className="title-dots-notizie before">
                      {renderIconFromTipoElementi()}
                    </span>
                  )}
                  <div className="title-dots-content">{title}</div>
                  {showDots && (dotsPosition === 'after' || dotsPosition === 'both') && (
                    <span className="title-dots-notizie after">
                      {renderIconFromTipoElementiDopo()}
                    </span>
                  )}
                </div>
              )}
              {bigTitle && (
                <h2 className="big-title">{bigTitle}</h2>
              )}

              {descrizione && (
                <div
                  className="description"
                  dangerouslySetInnerHTML={{ __html: descrizione.data }}
                />
              )}

              {linkApprofondimento && (
                <div className={`link-wrapper alignment-${titleAlignment}`}>
                  <UniversalLink
                    href={linkApprofondimento}
                    className="card-link simple-link"
                  >
                    {testoLink ? (testoLink) : ('Scopri di più →')}
                  </UniversalLink>
                </div>
              )}

              {titleText && (
                <h1 className="banner-titletext">{titleText}</h1>
              )}

              {text && (
                <p className="banner-text">{text}</p>
              )}

              {buttonText && buttonLink && (
                <div className={`button-wrapper alignment-${titleAlignment}`}>
                  <UniversalLink href={buttonLink} className="banner-button">
                    {buttonText}
                  </UniversalLink>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotiziaInEvidenzaView;